import * as r from 'ramda';
import * as loadingActions from '../../components/loading/actions';
import * as pcActions from '../../widgets/product-configurator/actions';
import * as submitActions from '../../widgets/product-configurator-submit/actions';

const stateToconfiguredProductProductConfigs = r.pipe(
    r.path(['productConfigurator', 'productConfigs']),
    r.values,
    r.filter(r.propSatisfies(r.lt(0), 'count')),
    r.map((pc) => ({
        productConfig: pc.id,
        count: pc.count,
    }))
);

export function nameProduct() {
    return function (dispatch, getState) {
        dispatch(loadingActions.show('productConfigurator', 'name'));

        const state = getState();
        const name = r.path(
            ['productConfigurator', 'namedProduct', 'name'],
            state
        );

        $.ajax({
            url: r.path(
                ['productConfigurator', 'actions', 'name', 'url'],
                state
            ),
            method: 'POST',
            data: {
                configured_product: {
                    name: name,
                    productVariant: r.path(
                        ['productConfigurator', 'selectedVariant'],
                        state
                    ),
                    configuredProductProductConfigs:
                        stateToconfiguredProductProductConfigs(state),
                },
            },
        })
            .done(() => {
                dispatch(pcActions.updateNameErrors([]));
                dispatch(submitActions.sendConfiguratorForm());
            })
            .fail((jqXhr) => {
                dispatch(loadingActions.hide('productConfigurator', 'name'));
                let errors = [];

                if (jqXhr.status === 400) {
                    const response = JSON.parse(jqXhr.responseText);
                    errors = r.propOr([], 'errors', response);
                    dispatch(
                        pcActions.updateNameErrors(
                            r.propOr([], 'errors', response)
                        )
                    );
                }

                if (errors.length === 0) {
                    errors = [
                        r.path(
                            [
                                'productConfigurator',
                                'namedProduct',
                                'unknownError',
                            ],
                            state
                        ),
                    ];
                }

                dispatch(pcActions.updateNameErrors(errors));
                dispatch(pcActions.updateName(''));
            });
    };
}
